var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWeatherSquall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.21 9.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #667085;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.07,
    y1: 4.78,
    x2: 8.4,
    y2: 4.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.57,
    y1: 4.78,
    x2: 0.5,
    y2: 4.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.5,
    y1: 6.28,
    x2: 0.82,
    y2: 6.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.09,3.07h2.97s2.63.23,2.63-1.37-2.5-1.63-2.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2.4,6.29h4.91s2.63-.23,2.63,1.38-2.5,1.64-2.5,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.28,
    y1: 3.09,
    x2: 0.5,
    y2: 3.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m9.94,4.79h1.14s2.63-.23,2.63,1.38-2.5,1.64-2.5,0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherSquall);
export default __webpack_public_path__ + "static/media/icon_weather_squall.e562d6f0e28f0238b46a62ffb7adae39.svg";
export { ForwardRef as ReactComponent };